module.exports = __webpack_public_path__ + "img/help_statistics.6a05d377.png";